<template>
  <div id="schedulePlaytime" :class="[schedulePlaytimeWrapperExtraClassname]" ref="schedulePlaytime">
    <!-- Playtime list -->
    <div class="playtime-list">
      <template v-for="(time) in scheduleTimeList" :key="time.uid">
        <div
          :class="['time', {'is-selected': (selectedPlaytimeItem !== null && selectedPlaytimeItem.uid === time.uid),
          'hidden': !time._edit.isVisible || (componentUsedInSchedulePage),
          'empty-time-tag': time._edit.emptyTimeTag}]">

          <div class="playtime-background"></div>
          <div :class="['details', {'has-priority-icon': time.priority}]">
            <div class="playtime-title">{{time._edit.title}}</div>
          </div>

          <div @click="handlePlayTimeRowClick(time)" class="time-cover prevent-confirm-playtime-form"></div>
          <div @click="handleScheduleTimeListData(scheduleTimeListActions.deletePlayTime, time)" class="remove-icon prevent-confirm-playtime-form"></div>
        </div>
      </template>
    </div>

    <!-- Edit Playtime Form -->
    <playtime-form v-if="selectedPlaytimeItem !== null && selectedPlaytimeItem.uid && !showNewPlayTimeForm"
      ref="editPlaytimeForm"
      :playtimeProp="selectedPlaytimeItem"
      :parentAccessorComponentProp="parentAccessorComponent"
      :mediaSelectionProp="mediaSelection"
      @playtime-form-change="handlePlaytimeFormChange($event)">
    </playtime-form>

    <!-- Add Playtime from timeTags selectbox -->
    <div id="playtimeFromTimeTagsWrapper" v-if="timeTagShowSelectbox" :class="[{'loading': timeTagGetStatus && !timeTagInitialLoad}]">
      <loader v-if="timeTagGetStatus && !timeTagInitialLoad" :isRequesting="true" :textLabel="''"></loader>
      <el-select v-if="!timeTagGetStatus"
        ref="timeTagSelectbox"
        v-model="timeTagNewValue"
        :placeholder="$t('label.select')"
        :popper-class="'schedule-time-tag-options-popper'"
        :class="['cstm-selectbox-grey time-tag-selectbox']"
        :automatic-dropdown="true"
        @change="handleNewTimeTagChange">

        <template v-for="(item, key) in timeTagList" :key="key">
          <el-option :class="['target-item-wrapper', 'display-block', `el-select-dropdown__item_${item.name}`]" :value="item">
            <span class="target-item">
              <i :class="['background-color']" :style="{'background-color': item._edit.backgroundColor }"></i>
              <i class="target-name uppercase">{{item._edit.title}}</i>
            </span>
          </el-option>
        </template>
      </el-select>
    </div>

    <!-- Create New Playtime (+) Button -->
    <el-button v-if="!componentUsedInSchedulePage && !timeTagShowSelectbox && !hideNewScheduleButton"
      @click="handleNewScheduleClick"
      :class="['plus-btn create-new-playtime-btn', 'prevent-confirm-playtime-form']">
    </el-button>
  </div>
</template>

<script src="./schedule-playtime-menu-item.js"></script>
<style lang="scss" src="./schedule-playtime-menu-item.scss"></style>
